import { BasePropertyApi } from './base-api.interface';
import { getTextColor } from './get-common-properties';
import { updateTextColor } from './update-common-properties';

export const textColorAPI: BasePropertyApi = {
  get: getTextColor,
  update: updateTextColor,
};
